import Cookies from 'js-cookie';

// eslint-disable-next-line import/no-anonymous-default-export
const VISIT_ID_COOKIE_NAME = 'VisitId';

export const set = (VisitId) => Cookies.set(VISIT_ID_COOKIE_NAME, VisitId);

export const get = () => Cookies.get(VISIT_ID_COOKIE_NAME);

export default () => {
    return get();
}
